export enum EStorageType {
  Token = "TOKEN",
  TokenFirebase = "TOKEN_FIREBASE",
  PostalCode = "POSTAL_CODE",
  RefresToken = "REFRES_TOKEN",
  Role = "ROLE",
  Coworking = "COWORKING",
  ActiveCoworking = "ACTIVECOWORKING",
  Company = "COMPANY",
  ActiveCompany = "ACTIVECOMPANY",
  Coworker = "COWORKER",
  Admin = "ADMIN",
  Language = "LANGUAGE",
  DownloadApp = "DOWNLOAD_APP"
}
